import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';

const Icons = {
  Trophy: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
      <path d="M4 22h16"/>
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
    </svg>
  ),
  Fire: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
    </svg>
  ),
  Brain: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/>
      <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/>
    </svg>
  ),
  DollarSign: ({ size = 20 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="1" x2="12" y2="23"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  Bolt: ({ size = 48 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="13 2 3 14 11 14 9 22 21 10 13 10 13 2"/>
    </svg>
  ),
  Cards: ({ size = 48 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="13" height="16" rx="2"/>
      <path d="M7 8h9a2 2 0 0 1 2 2v10"/>
    </svg>
  ),
  Wallet: ({ size = 48 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="12" rx="2"/>
      <path d="M16 12h4"/>
      <path d="M2 9h20"/>
    </svg>
  ),
  Confetti: ({ size = 64 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 21l9-9"/>
      <path d="M14 3l1 3 3 1"/>
      <path d="M6 6l1.5 1.5L6 9"/>
      <path d="M18 14l3 3"/>
      <path d="M8 21l-1-4 4 1"/>
    </svg>
  ),
  Check: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  ),
  Book: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    </svg>
  ),
  Users: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  Shield: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 2l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-4z"/>
    </svg>
  ),
  Award: ({ size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="8" r="4"/>
      <path d="M8.21 13.89 7 22l5-3 5 3-1.21-8.11"/>
    </svg>
  )
};

export default function StudentGames() {
  const { gamificationStats, gamesData, saveGamification } = useData();
  const { user } = useAuth();
  const hasStats = Boolean(gamificationStats);
  const savedScoresRef = useRef({ quiz: false, decision: false, budget: false });
  const [activeGame, setActiveGame] = useState(null);
  const [decisionIndex, setDecisionIndex] = useState(0);
  const [decisionScore, setDecisionScore] = useState(0);
  const [decisionCompleted, setDecisionCompleted] = useState(false);
  const [budget, setBudget] = useState({
    tithesGenerosity: 10,
    savingsInvestments: 20,
    householdNeeds: 35,
    businessSkills: 15,
    emergencyReserve: 10,
    legacyGiving: 10
  });

  const [quizState, setQuizState] = useState({
    current: 0,
    score: 0,
    timeLeft: 60,
    completed: false
  });

  const userName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Student';

  const recordScore = useCallback(async (key, points, badge) => {
    if (!user?.id || savedScoresRef.current[key]) return;
    savedScoresRef.current[key] = true;
    await saveGamification({
      userId: user.id,
      name: userName,
      pointsDelta: points,
      badge
    });
  }, [saveGamification, user?.id, userName]);

  const startQuiz = () => {
    setQuizState({
      current: 0,
      score: 0,
      timeLeft: 60,
      completed: false
    });
    savedScoresRef.current.quiz = false;
    setActiveGame('quiz');
  };

  const startDecisionLab = () => {
    setDecisionIndex(0);
    setDecisionScore(0);
    setDecisionCompleted(false);
    savedScoresRef.current.decision = false;
    setActiveGame('decision');
  };

  const startBudgetBuilder = () => {
    setBudget({
      tithesGenerosity: 10,
      savingsInvestments: 20,
      householdNeeds: 35,
      businessSkills: 15,
      emergencyReserve: 10,
      legacyGiving: 10
    });
    savedScoresRef.current.budget = false;
    setActiveGame('budget');
  };

  const handleQuizAnswer = (optionIndex) => {
    const correct = gamesData.quizRush.questions[quizState.current].correct;
    if (optionIndex === correct) {
      setQuizState(prev => ({ ...prev, score: prev.score + 100 }));
    }
    
    if (quizState.current < gamesData.quizRush.questions.length - 1) {
      setQuizState(prev => ({ ...prev, current: prev.current + 1 }));
    } else {
      setQuizState(prev => ({ ...prev, completed: true }));
    }
  };

  const totalAllocated = Object.values(budget).reduce((a, b) => a + b, 0);
  const isBalanced = totalAllocated === 100;

  useEffect(() => {
    if (quizState.completed && quizState.score > 0) {
      recordScore('quiz', quizState.score, 'Covenant Challenge');
    }
  }, [quizState.completed, quizState.score, recordScore]);

  useEffect(() => {
    if (decisionCompleted && decisionScore > 0) {
      recordScore('decision', decisionScore, 'Decision Lab');
    }
  }, [decisionCompleted, decisionScore, recordScore]);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Rewards & Games</h1>
        <p className="page-subtitle">Learn, earn points, and unlock rewards!</p>
      </div>

      {/* Points Overview */}
      <div className="stats-grid" style={{ marginBottom: '24px' }}>
        <div className="card card-gold" style={{ gridColumn: 'span 2' }}>
          <div className="card-body" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
            <div style={{ 
              width: '80px', 
              height: '80px', 
              background: 'rgba(255,255,255,0.2)', 
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Icons.Trophy />
            </div>
            <div style={{ color: 'white' }}>
              <div style={{ fontSize: '0.875rem', opacity: 0.9, marginBottom: '4px' }}>Total Points</div>
              <div style={{ fontSize: '3rem', fontWeight: '700' }}>{hasStats ? (gamificationStats?.points ?? 0) : '—'}</div>
              <div style={{ fontSize: '0.875rem', opacity: 0.8 }}>
                {hasStats ? 'Leaderboard updates after each game.' : 'No game stats yet.'}
              </div>
            </div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon gold">
            <Icons.Fire />
          </div>
          <div className="stat-content">
            <div className="stat-value">{hasStats ? (gamificationStats?.streaks?.attendance ?? 0) : '—'}</div>
            <div className="stat-label">Attendance Streak</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon green">
            <Icons.Brain />
          </div>
          <div className="stat-content">
            <div className="stat-value">{hasStats ? (gamificationStats?.streaks?.study ?? 0) : '—'}</div>
            <div className="stat-label">Study Streak</div>
          </div>
        </div>
      </div>

      {/* Badges */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <div className="card-header">
          <h3 style={{ fontSize: '1.125rem' }}>Your Badges</h3>
        </div>
        <div className="card-body">
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {gamificationStats?.badges?.map(badge => {
              const BadgeIcon = Icons[badge.icon] || Icons.Award;
              return (
                <div 
                  key={badge.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '16px',
                    background: badge.earned ? 'var(--gray-50)' : 'var(--gray-100)',
                    borderRadius: '12px',
                    opacity: badge.earned ? 1 : 0.5
                  }}
                >
                  <div style={{ 
                    filter: badge.earned ? 'none' : 'grayscale(100%)'
                  }}>
                    <BadgeIcon size={28} />
                  </div>
                  <div>
                    <div style={{ fontWeight: '500', fontSize: '0.9375rem' }}>{badge.name}</div>
                    <div style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>
                      {badge.earned ? `Earned: ${badge.date}` : 'Not earned yet'}
                    </div>
                  </div>
                </div>
              );
            })}
            {!gamificationStats?.badges?.length && (
              <div style={{ color: 'var(--gray-500)' }}>
                No badges earned yet. Play a game to unlock your first badge.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Games Grid */}
      <div style={{ display: 'flex', gap: '24px', marginBottom: '24px' }}>
        <div 
          className="card" 
          style={{ flex: 1, cursor: 'pointer' }}
          onClick={startQuiz}
        >
          <div className="card-body" style={{ textAlign: 'center', padding: '32px' }}>
            <div style={{ marginBottom: '16px', color: 'var(--primary)' }}>
              <Icons.Bolt size={48} />
            </div>
            <h3 style={{ marginBottom: '8px' }}>Covenant Challenge</h3>
            <p style={{ color: 'var(--gray-500)', fontSize: '0.875rem', marginBottom: '16px' }}>
              Rapid-fire Kingdom economics quiz with fresh weekly questions
            </p>
            <button className="btn btn-primary">Play Now</button>
          </div>
        </div>

        <div 
          className="card" 
          style={{ flex: 1, cursor: 'pointer' }}
          onClick={startDecisionLab}
        >
          <div className="card-body" style={{ textAlign: 'center', padding: '32px' }}>
            <div style={{ marginBottom: '16px', color: 'var(--primary)' }}>
              <Icons.Cards size={48} />
            </div>
            <h3 style={{ marginBottom: '8px' }}>Decision Lab</h3>
            <p style={{ color: 'var(--gray-500)', fontSize: '0.875rem', marginBottom: '16px' }}>
              Choose the best response for real-world Kingdom scenarios
            </p>
            <button className="btn btn-primary">Play Now</button>
          </div>
        </div>

        <div 
          className="card" 
          style={{ flex: 1, cursor: 'pointer' }}
          onClick={startBudgetBuilder}
        >
          <div className="card-body" style={{ textAlign: 'center', padding: '32px' }}>
            <div style={{ marginBottom: '16px', color: 'var(--gold-dark)' }}>
              <Icons.Wallet size={48} />
            </div>
            <h3 style={{ marginBottom: '8px' }}>Stewardship Planner</h3>
            <p style={{ color: 'var(--gray-500)', fontSize: '0.875rem', marginBottom: '16px' }}>
              Build a balanced plan for giving, growth, and household priorities
            </p>
            <button className="btn btn-primary">Play Now</button>
          </div>
        </div>
      </div>

      {/* Active Game Area */}
      {activeGame && (
        <div className="card">
          <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ fontSize: '1.125rem' }}>
              {activeGame === 'quiz' && 'Covenant Challenge'}
              {activeGame === 'decision' && 'Decision Lab'}
              {activeGame === 'budget' && 'Stewardship Planner'}
            </h3>
            <button className="btn btn-ghost btn-sm" onClick={() => setActiveGame(null)}>
              Close Game
            </button>
          </div>
          <div className="card-body">
            {/* Quiz Game */}
            {activeGame === 'quiz' && (
              <div>
                {!quizState.completed ? (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
                      <div style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                        Score: {quizState.score}
                      </div>
                      <div style={{ fontSize: '1.25rem', fontWeight: '600', color: quizState.timeLeft < 10 ? 'var(--danger)' : 'var(--primary)' }}>
                        Time: {quizState.timeLeft}s
                      </div>
                    </div>
                    <div style={{ marginBottom: '24px' }}>
                      <div style={{ fontSize: '0.875rem', color: 'var(--gray-500)', marginBottom: '8px' }}>
                        Question {quizState.current + 1} of {gamesData.quizRush.questions.length}
                      </div>
                      <h4 style={{ fontSize: '1.125rem', marginBottom: '20px' }}>
                        {gamesData.quizRush.questions[quizState.current].question}
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {gamesData.quizRush.questions[quizState.current].options.map((option, i) => (
                          <button
                            key={i}
                            className="quiz-option"
                            onClick={() => handleQuizAnswer(i)}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <div style={{ textAlign: 'center', padding: '48px' }}>
                    <div style={{ marginBottom: '16px', color: 'var(--gold)' }}>
                      <Icons.Confetti size={64} />
                    </div>
                    <h2 style={{ marginBottom: '8px' }}>Quiz Complete!</h2>
                    <p style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--primary)', marginBottom: '8px' }}>
                      Final Score: {quizState.score}
                    </p>
                    <p style={{ color: 'var(--gray-500)' }}>
                      {quizState.score >= 300 ? 'Excellent!' : quizState.score >= 200 ? 'Good job!' : 'Keep practicing!'}
                    </p>
                    <button
                      className="btn btn-primary"
                      style={{ marginTop: '16px' }}
                      onClick={() => recordScore('quiz', quizState.score, 'Covenant Challenge')}
                      disabled={!user?.id}
                    >
                      Save Score
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Decision Lab Game */}
            {activeGame === 'decision' && (
              <div>
                {!decisionCompleted ? (
                  <div style={{ display: 'grid', gap: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--gray-500)' }}>
                      <div>Scenario {decisionIndex + 1} of {gamesData.decisionLab.scenarios.length}</div>
                      <div>Score: {decisionScore}</div>
                    </div>
                    <div>
                      <h4 style={{ fontSize: '1.125rem', marginBottom: '16px' }}>
                        {gamesData.decisionLab.scenarios[decisionIndex].prompt}
                      </h4>
                      <div style={{ display: 'grid', gap: '12px' }}>
                        {gamesData.decisionLab.scenarios[decisionIndex].options.map((option, idx) => (
                          <button
                            key={option}
                            className="quiz-option"
                            onClick={() => {
                              const currentScenario = gamesData.decisionLab.scenarios[decisionIndex];
                              const correct = idx === currentScenario.correct;
                              if (correct) {
                                setDecisionScore(prev => prev + 100);
                              }
                              if (decisionIndex < gamesData.decisionLab.scenarios.length - 1) {
                                setDecisionIndex(prev => prev + 1);
                              } else {
                                setDecisionCompleted(true);
                              }
                            }}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ fontSize: '0.85rem', color: 'var(--gray-500)' }}>
                      {gamesData.decisionLab.scenarios[decisionIndex].feedback}
                    </div>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '48px' }}>
                    <div style={{ marginBottom: '16px', color: 'var(--gold)' }}>
                      <Icons.Confetti size={64} />
                    </div>
                    <h2 style={{ marginBottom: '8px' }}>Decision Lab Complete!</h2>
                    <p style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--primary)', marginBottom: '8px' }}>
                      Final Score: {decisionScore}
                    </p>
                    <p style={{ color: 'var(--gray-500)' }}>
                      {decisionScore >= 400 ? 'Excellent judgement!' : decisionScore >= 300 ? 'Strong decisions!' : 'Keep practicing!'}
                    </p>
                    <button
                      className="btn btn-primary"
                      style={{ marginTop: '16px' }}
                      onClick={() => recordScore('decision', decisionScore, 'Decision Lab')}
                      disabled={!user?.id}
                    >
                      Save Score
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Budget Builder Game */}
            {activeGame === 'budget' && (
              <div className="budget-builder">
                <p style={{ marginBottom: '24px', color: 'var(--gray-600)' }}>
                  Allocate resources across key stewardship priorities. Aim for a balanced 100% plan.
                </p>
                
                {Object.entries(budget).map(([key, value]) => (
                  <div key={key} className="budget-category">
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <label style={{ textTransform: 'capitalize' }}>{key.replace(/([A-Z])/g, ' $1').trim()}</label>
                      <span style={{ fontWeight: '600' }}>{value}%</span>
                    </div>
                    <input
                      type="range"
                      min="0"
                      max="50"
                      value={value}
                      onChange={(e) => setBudget({ ...budget, [key]: parseInt(e.target.value) })}
                      style={{ width: '100%' }}
                    />
                  </div>
                ))}

                <div className="budget-total">
                  <h4>Total Allocated</h4>
                  <div className={`balance ${isBalanced ? 'positive' : 'negative'}`}>
                    {totalAllocated}%
                  </div>
                  <p style={{ color: isBalanced ? 'var(--success)' : 'var(--danger)', marginTop: '8px' }}>
                    {isBalanced ? 'Perfectly balanced budget!' : `${100 - totalAllocated}% unallocated`}
                  </p>
                  <button
                    className="btn btn-primary"
                    style={{ marginTop: '16px' }}
                    onClick={() => recordScore('budget', 150, 'Stewardship Planner')}
                    disabled={!isBalanced || !user?.id}
                  >
                    Save Budget Score
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

    </div>
  );
}
